var map = {
	"./completed-job-active.svg": 23759,
	"./completed-job.svg": 43476,
	"./gateway-active.svg": 73258,
	"./gateway.svg": 13107,
	"./job-active.svg": 39047,
	"./job.svg": 55484,
	"./none-active.svg": 94852,
	"./none.svg": 44761,
	"./phone-active.svg": 60720,
	"./phone.svg": 73245,
	"./service-active.svg": 80031,
	"./service.svg": 55076,
	"./unnamed-active.svg": 6080,
	"./unnamed.svg": 42701,
	"./vehicle-active.svg": 73360,
	"./vehicle.svg": 95805,
	"./warehouse-active.svg": 46431,
	"./warehouse.svg": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87259;